import { render, staticRenderFns } from "./PoolsListStandard.vue?vue&type=template&id=53a3cfd3"
import script from "./PoolsListStandard.vue?vue&type=script&lang=ts"
export * from "./PoolsListStandard.vue?vue&type=script&lang=ts"
import style0 from "./PoolsListStandard.vue?vue&type=style&index=0&id=53a3cfd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports